export default [
  { name: 'Code', prop: 'code', type: 'text' }
]
